import React, { useEffect, useState } from "react";
import "./expensesStyle.css";
import CustomTable from "../../../../components/custom_table/CustomTable";
import { useNavigate } from "react-router-dom";
import { BiEditAlt } from "react-icons/bi";
import ExpenseFilter from "./expense_filter/ExpenseFilter";
import CustomBottomPagination from "../../../../components/custom_bottom_pagination/CustomBottomPagination";
import { LocalStorageServices } from "../../../../services/localStorageServices";
import { get_expense_head } from "../../../../api/expenseHeadApis";

function Expenses() {
  const navigate = useNavigate();
  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/master_settings`;
  const [expensesList, setExpensesList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItemPerPage, setTotalItemPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [searchFilter, setSearchFilter] = useState(null);

  useEffect(() => {
    getExpenses(pageNumber, searchFilter);
  }, [pageNumber, totalItemPerPage]);

  // Privilege helpers
  const getPrivilegesDetails = () =>
    JSON.parse(localStorage.getItem("privileges_details") || "[]");

  const hasPrivilege = (privilegeName) =>
    getPrivilegesDetails().some(
      (item) =>
        item.module_name === "Master Settings" &&
        item.submodules?.["Expenses Head"]?.privileges?.some(
          (priv) => priv.name === privilegeName
        )
    );

  //  below if privileges are needed
  const canAdd = hasPrivilege("Add");
  const canEdit = hasPrivilege("Edit");

  const [isLoading, setIsLoading] = useState(true);

  const getExpenses = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append("page", pageNumber);
    formData.append("pageItem_count", totalItemPerPage);
    if (filterValue) {
      formData.append("ExpenseName", filterValue?.name);
      formData.append("status", filterValue?.status_id);
    }
    get_expense_head(formData)
      .then((response) => {
        if (response.data.data.data.length > 0) {
          setExpensesList(response.data.data.data);
          setTotalPages(response.data.data.last_page);
        } else {
          setExpensesList([]);
          setTotalPages(0);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      wrapper: (row) => (
        <div>
          <p
            style={{
              color: row.status == "Active" ? "#0A9E02" : "#FF0000",
              textAlign: !canEdit ? "center" : "",
            }}
          >
            {row.status}
          </p>
        </div>
      ),
    },
    canEdit && {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BiEditAlt
            className="locations_action_edit"
            onClick={() =>
              navigate(baseRouteUrl + `/${row.id}/update_expense_head`)
            }
          />
        </div>
      ),
    },
  ].filter(Boolean); // removes false/null entries

  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount);
  };
  const datas = () => {
    const result =
      expensesList &&
      expensesList.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item.expense_head_id,
          name: item.ExpenseName,
          status: item?.status?.status_name,
        };
      });
    return result;
  };
  const searchfilter = (value) => {
    setSearchFilter(value);
    if (value) {
      console.log(pageNumber, value);
      getExpenses(pageNumber, value);
    } else {
      getExpenses(1, value);
      setPageNumber(1);
    }
  };
  return (
    <div className="locations_module_main_container">
      <p className="locations_title">Expenses Head</p>

      <div className="locations_module_filter">
        <ExpenseFilter searchFilter={searchfilter} />
        {canAdd && (
          <button
            className="locations_add_button"
            onClick={() => navigate(baseRouteUrl + `/create_new_expense_head`)}
          >
            Add New
          </button>
        )}
      </div>

      <div className="locations_table_main_container">
        <CustomTable columns={Columns} rows={datas()} loading={isLoading} />
      </div>
      <div>
        <CustomBottomPagination
          total_items_per_page={10}
          total_page_count={totalPages}
          current_page={pageNumber}
          on_change_value={updatePagination}
          on_page_count_update={updateItemPageCount}
        />
      </div>
    </div>
  );
}

export default Expenses;
